module.exports = __webpack_public_path__ + "static/media/bg-diamond.02ce59c1.png";